export default {
  EOT: 253392484149,
  MAX_OPTIONS_DISPLAY: 15,
  IMPORT_DATE_POLLING: 300000,
};

export const LEGAL_TEAM_ID = /^[0-9A-NP-Z]{8}$/;

export const DEFAULT_DATE_FORMAT = "DD/MM/YYYY";

export const DEFAULT_DATE_TIME_FORMAT = "DD/MM/YYYY HH:mm:ss";

export const READABLE_DATE_FORMAT = "DD MMM YYYY";

export const API_DATE_FORMAT = "YYYY-MM-DD";

export const NOOP = () => {};

export const DEBOUNCE_SEARCH_TIME = 500;
